import React from 'react';
import styles from './HadrahaPage.module.css';
import logo from './images/המשרד לוגו.png';

const HadrahaPage = () => {
  return (
    <div className={styles.container}>
      {/* אלמנטים דקורטיביים */}
      <div className={styles.blobGold}></div>
      <div className={styles.blobBrown}></div>
      <div className={styles.blobAccent1}></div>
      <div className={styles.blobAccent2}></div>

      <div className={styles.contentWrapper}>
        {/* לוגו */}
        <img src={logo} alt="המשרד לוגו" className={styles.logo} />

        {/* כותרת ראשית */}
        <h1 className={styles.title}>
          איך פותחים עסק בניהול ואדמיניסטרציה
        </h1>

        {/* תגית תאריך */}
        <div className={styles.dateBadge}>
          <p className={styles.dateBadgeText}>
            לייב חמישי הקרוב | 26/2 | 20:30
          </p>
        </div>

        {/* תת כותרת */}
        <p className={styles.subtitle}>
          הדרכה חינמית בלייב שתראה לך איך להתחיל מאפס
          <br />
          ולצאת לעצמאות בצורה מסודרת - גם בלי ניסיון.
        </p>

        {/* מה תקבלי בלייב */}
        <div className={styles.card}>
          <h2 className={styles.cardTitle}>מה תקבלי בלייב</h2>
          <ul className={styles.checkList}>
            <li className={styles.checkItem}>
              <span className={styles.checkIcon}>✔</span>
              איך מגדירים שירות שאפשר למכור
            </li>
            <li className={styles.checkItem}>
              <span className={styles.checkIcon}>✔</span>
              איך מתמחרים נכון מההתחלה
            </li>
            <li className={styles.checkItem}>
              <span className={styles.checkIcon}>✔</span>
              איך משיגים לקוחות ראשונים
            </li>
          </ul>
        </div>

        {/* פרטי מפגש */}
        <div className={styles.meetingDetails}>
          <span className={styles.meetingItem}>📍 Google Meet</span>
          <span className={styles.meetingItem}>🗓 חמישי</span>
          <span className={styles.meetingItem}>⏰ 20:30</span>
        </div>

        {/* כפתור CTA */}
        <a
          href="https://chat.whatsapp.com/GNzRznEehrnGD6KNI3zXqh?mode=gi_t"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaButton}
        >
          הצטרפי עכשיו לקבוצת ההדרכה
        </a>
      </div>
    </div>
  );
};

export default HadrahaPage;